module.exports = __webpack_public_path__ + "img/ctrl-pauli-z-root-stub-mid--.52eb24d1.svg";